import '../App.css';
import 'animate.css';
import screen1 from '../assets/images/theater-app-screengrab1.png';
import screen2 from '../assets/images/theater-app-screengrab2.png'; 

function ProjectTemplate() {
  return (
    <div className="App">
      <div className="home-container">
        <h1 className="scroll-down-arrow animate__animated animate__fadeInDown animate__slow animate__delay-1s">↓</h1>
        <h5 className="animate__animated animate__fadeIn animate__slow animate__delay-1s">a.mcknight<span className="grey">.digital</span></h5>
        <a href="/">
          <h5 className="animate__animated animate__fadeIn animate__slow animate__delay-1s">← return home</h5>
        </a>
        <h1 className="animate__animated animate__fadeInUp animate__slow">evently</h1>
        <p className="animate__animated animate__fadeIn animate__slow animate__delay-2s">Bootstrap, Sqlite, .NET, C#, and Entity Framework</p>
        
        <div className="about animate__animated animate__fadeInUp animate__slower animate__delay-2s">
          <h3>
           Project Overview:
          </h3>
          <h2>
            Evently is an Web Application built for use by Live Event Venues such as Dinner Theaters or Concert Halls. The application has secure routes, and a Mysql database to store customer information. The application also uses dynamic rendering of information using Razor Pages. 
          </h2>
        </div>
        <div className="screenshots">
          <img src={screen1} alt="Screen shot of program."></img>
          <img src={screen2} alt="Screen shot of program."></img>
        </div>
        <div className="about">
          <h3>
           Project Features:
          </h3>
          <h2>
            <li>User log-in and registration using .NET Idenity</li>
            <li>C.R.U.D actions for Customers, and Reservations</li>
            <li>Company Intranet with Announcements, Calendar, and Featured News sections.</li>
            <li>Quick payment acceptance using Stripe as the backend service (not configured by default)</li>
            
          </h2>
        </div>
      
        <h3>View the Source Code at: <a target="_blank"  rel="noreferrer" href="https://github.com/apmcknight/theater-app">github.com/apmcknight/theater-app</a></h3>
       
        <h5 className="grey home-link">view privacy and site license —</h5>
      </div>

      
      
    </div>
  );
}

export default ProjectTemplate;
